// aifab - hooks/useForm.js
// Shared controlled form state with a single setter.
//
// Usage:
//   const { form, set, reset } = useForm({ name: '', email: '' });
//   <input value={form.name} onChange={e => set('name', e.target.value)} />

import { useState, useCallback } from 'react';

export function useForm(initial) {
  const [form, setForm] = useState(initial);

  const set = useCallback((key, value) => {
    setForm(f => ({ ...f, [key]: value }));
  }, []);

  const reset = useCallback(() => {
    setForm(initial);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const patch = useCallback((updates) => {
    setForm(f => ({ ...f, ...updates }));
  }, []);

  return { form, set, patch, reset, setForm };
}
